import React, { Component } from 'react';
import {
    LineChart,
    Line,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

import { StyledSimpleLineChart } from './style/StyledSimpleLineChart';
import { SelectColor } from '../../../../services/reports';

const CustomTooltip = ({ payload, active, channel }) => {
    if (active) {
        return (
	<div className="custom-tooltip">
		<strong className="label m-0">{payload[0].payload.name}</strong>
		<p className={`label m-0 label-clicks element-${channel}`}>{`${payload[0].name}: ${(payload[0].payload.clicks).toLocaleString('pt-BR')}`}</p>
		<p className={`label m-0 label-impressions element-${channel}`}>{`${payload[1].name}: ${(payload[0].payload.impressions).toLocaleString('pt-BR')}`}</p>
	</div>
        );
    }

    return null;
};

export default class GeneralVision extends Component {
    constructor(props) {
        super(props);

        const { data } = this.props;

        this.state = {
            firstDate: data[0],
            lastDate: data[data.length - 1],
        };
    }

    render() {
        const { data, typeChart, channel } = this.props;

        const { firstDate, lastDate } = this.state;

        return (
	<StyledSimpleLineChart>
		<div style={{ width: '100% !important', height: 350 }}>
			<ResponsiveContainer width="100%" debounce={1}>
				<LineChart
					data={data}
					margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
					width="100%"
				>
					<CartesianGrid strokeDasharray="3 3" width="100%" />
					<YAxis yAxisId="left" />
					<YAxis yAxisId="right" orientation="right" />
					<Tooltip content={<CustomTooltip channel={channel} />} />
					<Line
						name={(typeChart === 'generalVision') ? 'Cliques' : null}
						yAxisId="left"
						type="monotone"
						dataKey="clicks"
						stroke={SelectColor(channel, 'clicks')}
						strokeWidth="3px"
						activeDot={{ r: 8 }}
						isAnimationActive={false}
					/>
					<Line
						name={(typeChart === 'generalVision') ? 'Impressões' : null}
						yAxisId="right"
						type="monotone"
						dataKey="impressions"
						stroke={SelectColor(channel, 'impressions')}
						strokeWidth="2px"
						isAnimationActive={false}
					/>
				</LineChart>
			</ResponsiveContainer>
		</div>

		<div className="d-flex container-dates">
			<span>{(firstDate) ? firstDate.name : ''}</span>
			<span>{(lastDate) ? lastDate.name : ''}</span>
		</div>
	</StyledSimpleLineChart>
        );
    }
}
